import * as ActionTypes from "../../actions";
import status from "./status";

//Updates the status apiCalls data for different api call.
var authenticationApiCalls = {
  fetchAuthentication: status({
    mapActionToKey: function mapActionToKey(action) {
      return "undefined";
    },
    types: [ActionTypes.GET_AUTHENTICATION_REQUEST, ActionTypes.GET_AUTHENTICATION_SUCCESS, ActionTypes.GET_AUTHENTICATION_FAILURE, ActionTypes.REST_GET_AUTHENTICATION]
  })
};
export default authenticationApiCalls;